var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKeyG = function SvgKeyG(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4723_70281)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    width: 26.94,
    height: 26.94,
    rx: 1.796,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9016 11.369C16.8068 10.0167 15.7861 9.08009 14.2812 9.08009C12.529 9.08009 11.4819 10.2693 11.4819 12.2214V13.3158C11.4819 15.389 12.4711 16.5676 14.3128 16.5676C15.8124 16.5676 16.9279 15.5784 16.9279 14.2051V12.7265H14.218V13.4369H16.1649V14.2051C16.1649 15.1943 15.4019 15.8573 14.3128 15.8573C12.9763 15.8573 12.2607 14.9312 12.2607 13.3158V12.2214C12.2607 10.7007 13.0026 9.7957 14.2812 9.7957C15.3441 9.7957 16.0123 10.4219 16.1281 11.369H16.9016Z",
    fill: "#212B36"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.15,
    y: 0.15,
    width: 26.641,
    height: 26.641,
    rx: 1.646,
    stroke: "#212B36",
    strokeWidth: 0.299
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4723_70281",
    x: 0.401,
    y: 0,
    width: 28.138,
    height: 28.736,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.599,
    operator: "dilate",
    "in": "SourceAlpha",
    result: "effect1_dropShadow_4723_70281"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.197
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4723_70281"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4723_70281",
    result: "shape"
  })))));
};
export default SvgKeyG;